<template>
  <div v-if="isShow" class="bg-blue-100 py-3 tablet:py-4 desktop:py-[18px]">
    <div class="container-wrap relative">
      <div class="flex items-center">
        <div class="flex flex-1 items-center tablet:justify-center">
          <p
            class="mr-4 line-clamp-3 flex-1 text-sm leading-5 tablet:line-clamp-2 tablet:max-w-[450px] tablet:text-center desktop:max-w-[600px]"
          >
            {{ itemData.title }}
          </p>
          <TheNuxtLink
            v-if="itemData.btnText"
            :id="itemData.trackingCode"
            :title="itemData.btnText"
            :to="provideFormatUrl(itemData.link)"
            class="flex items-center text-sm font-bold text-blue-400 hover:text-blue-500"
          >
            <span class="hidden tablet:inline tablet:max-w-32 tablet:truncate">
              {{ itemData.btnText }}
            </span>
            <IconArrow
              class="block h-6 w-6 basis-6 tablet:ml-1"
              direction="right"
            />
          </TheNuxtLink>
        </div>
        <a
          :id="itemData.closeTrackingCode"
          href="javascript:;"
          class="block h-6 w-6 basis-6 text-gray-600 hover:text-blue-400"
          @click="handleClose"
        >
          <IconClose class="h-full w-full" />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface IAnnouncement {
    title: string;
    link: string;
    btnText: string;
    trackingCode?: string;
    closeTrackingCode?: string;
  }

  interface IProps {
    itemData: IAnnouncement;
  }

  const props = defineProps<IProps>();

  const { provideFormatUrl } = useFormatUrl();

  const isClosed = ref<boolean>(false);

  const isShow = computed((): boolean => {
    if (isClosed.value) return false;
    return !!(props.itemData && props.itemData?.title);
  });

  const handleClose = (): void => {
    isClosed.value = true;
  };

  export type { IAnnouncement };
</script>
